<template>
  <section id="services" class="services-section">
    <div class="container">
      <p class="pre-label">ماذا نقدم</p>
      <h2 class="section-title">خدماتنا الاحترافية</h2>
      <div class="gold-divider" />
      <p class="section-subtitle">
        نوفر حلولاً رقمية متكاملة تجمع بين الإبداع التقني والجماليات البصرية
      </p>

      <div class="services-grid">
        <div
          v-for="(service, i) in services"
          :key="service.title"
          class="service-card"
          :style="{ '--delay': i * 0.1 + 's' }"
        >
          <div class="service-icon-wrap">
            <span class="service-icon">{{ service.icon }}</span>
            <div class="icon-glow" />
          </div>
          <h3 class="service-title">{{ service.title }}</h3>
          <p class="service-desc">{{ service.desc }}</p>
          <ul class="service-features">
            <li v-for="f in service.features" :key="f">
              <span class="check">✓</span> {{ f }}
            </li>
          </ul>
          <div class="service-line" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const services = [
  {
    icon: "💻",
    title: "تطوير تطبيقات الويب",
    desc: "نبني تطبيقات ويب سريعة وآمنة بأحدث التقنيات مع واجهات مستخدم استثنائية.",
    features: [
      "Vue.js / React / Next.js",
      "Node.js & Laravel",
      "قواعد بيانات متقدمة",
      "APIs احترافية",
    ],
  },
  {
    icon: "📱",
    title: "تطبيقات الجوال",
    desc: "تطبيقات موبايل متوافقة مع iOS وAndroid بأداء عالٍ وتجربة مستخدم سلسة.",
    features: [
      "Flutter & React Native",
      "تصميم UI/UX عصري",
      "تكامل مع الخوادم",
      "نشر في المتاجر",
    ],
  },
  {
    icon: "🎨",
    title: "تصميم الجرافيك",
    desc: "هوية بصرية متكاملة ومواد تسويقية تعكس احترافية علامتك التجارية.",
    features: [
      "هوية بصرية كاملة",
      "تصميم منشورات السوشيال",
      "بروشورات وكروت",
      "إعلانات رقمية",
    ],
  },
  {
    icon: "🛒",
    title: "المتاجر الإلكترونية",
    desc: "متاجر إلكترونية متكاملة تربط منتجاتك بالعملاء وتزيد مبيعاتك.",
    features: [
      "بوابات دفع آمنة",
      "لوحة تحكم سهلة",
      "تقارير وإحصاءات",
      "تكامل مع الشحن",
    ],
  },
  {
    icon: "🔍",
    title: "تحسين محركات البحث",
    desc: "نضع موقعك في صدارة نتائج Google بأساليب SEO مثبتة الكفاءة.",
    features: [
      "تحليل الكلمات المفتاحية",
      "تحسين السرعة والأداء",
      "بناء روابط خلفية",
      "تقارير شهرية",
    ],
  },
  {
    icon: "☁️",
    title: "خدمات السحابة والدعم",
    desc: "استضافة احترافية وصيانة مستمرة لضمان تشغيل مشروعك 24/7 بكامل كفاءته.",
    features: [
      "استضافة VPS وCloud",
      "نسخ احتياطي دوري",
      "أمان وحماية متقدمة",
      "دعم فني مستمر",
    ],
  },
];
</script>

<style scoped>
.services-section {
  padding: 7rem 6vw;
  background: var(--bg-dark);
  position: relative;
}

.services-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--gold), transparent);
}

.container {
  max-width: 1300px;
  margin: 0 auto;
}

.pre-label {
  text-align: center;
  color: var(--gold);
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 1.5rem;
}

.service-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 20px;
  padding: 2.2rem;
  position: relative;
  overflow: hidden;
  transition: all 0.4s ease;
  animation: fadeInUp 0.6s var(--delay, 0s) ease both;
  cursor: default;
}

.service-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(
    circle at 80% 10%,
    rgba(212, 175, 55, 0.06),
    transparent 60%
  );
  opacity: 0;
  transition: opacity 0.4s;
}

.service-card:hover {
  transform: translateY(-6px);
  border-color: rgba(212, 175, 55, 0.5);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(212, 175, 55, 0.15);
}

.service-card:hover::before {
  opacity: 1;
}

.service-icon-wrap {
  position: relative;
  width: 64px;
  height: 64px;
  margin-bottom: 1.5rem;
}

.service-icon {
  font-size: 2.2rem;
  display: block;
  line-height: 64px;
  text-align: center;
  width: 64px;
  height: 64px;
  background: rgba(212, 175, 55, 0.1);
  border-radius: 16px;
  border: 1px solid var(--border);
  transition: all 0.3s;
}

.service-card:hover .service-icon {
  background: rgba(212, 175, 55, 0.2);
  border-color: var(--gold);
}

.icon-glow {
  position: absolute;
  inset: -4px;
  border-radius: 20px;
  background: var(--gold-glow);
  filter: blur(12px);
  opacity: 0;
  transition: opacity 0.3s;
}

.service-card:hover .icon-glow {
  opacity: 1;
}

.service-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--gold-light);
  margin-bottom: 0.8rem;
}

.service-desc {
  color: var(--gray);
  font-size: 0.95rem;
  line-height: 1.7;
  margin-bottom: 1.4rem;
}

.service-features {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.service-features li {
  font-size: 0.88rem;
  color: rgba(245, 245, 240, 0.75);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.check {
  color: var(--gold);
  font-weight: 700;
  font-size: 0.8rem;
}

.service-line {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, var(--gold), transparent);
  transform: scaleX(0);
  transition: transform 0.4s ease;
}

.service-card:hover .service-line {
  transform: scaleX(1);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 700px) {
  .services-section {
    padding: 5rem 1.5rem;
  }
  .services-grid {
    grid-template-columns: 1fr;
  }
}
</style>
